/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to favorites`)
};

const es_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir a favoritos`)
};

const de_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Favoriten hinzufügen`)
};

const nl_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toevoegen aan favorieten`)
};

const fr_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter aux favoris`)
};

const it_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi ai preferiti`)
};

const pt_br2_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar aos favoritos`)
};

const pt_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar aos favoritos`)
};

const ja_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お気に入りに追加`)
};

const zh_fav_add = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加到收藏`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fav_add = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fav_add(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fav_add", locale)
	if (locale === "en") return en_fav_add(inputs)
	if (locale === "es") return es_fav_add(inputs)
	if (locale === "de") return de_fav_add(inputs)
	if (locale === "nl") return nl_fav_add(inputs)
	if (locale === "fr") return fr_fav_add(inputs)
	if (locale === "it") return it_fav_add(inputs)
	if (locale === "pt-BR") return pt_br2_fav_add(inputs)
	if (locale === "pt") return pt_fav_add(inputs)
	if (locale === "ja") return ja_fav_add(inputs)
	return zh_fav_add(inputs)
};